import {useEffect, useRef, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {checkDisplayValue, formatDate} from '../../../utils'
import {useQueryResponseData} from './groups-list/core/QueryResponseProvider'
import {getGroupmeetingById} from './groups-list/core/_requests'
import moment from 'moment'
import axios from 'axios'
import {apiUrl} from '../../../apiurl'
import Zoom from 'react-medium-image-zoom'

const API_URL = apiUrl
const ViewGroupMeetingReports = () => {
  const {id} = useParams()
  const [data, setData] = useState<any>([])
  const [isLoading, setIsLoading] = useState(true)
  const VIEWBYID_GROUPMEETING_URL = `${API_URL}/groupmeetingreports/viewreport`
  const navigate = useNavigate()
  const navigateGroupMeeting = () => {
    // 👇️ navigate to /
    navigate('/group-meeting-report')
  }

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      const res = await axios.get(`${VIEWBYID_GROUPMEETING_URL}/${id}`)
      setData(res?.data ?? {})
      setIsLoading(false)
    } catch (error) {
      console.log('Error -->:', error)
      setIsLoading(false)
    }
  }

  const styles = {
    borderRadius: '0.475rem',
    boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
    backgroundColor: '#fff',
    color: '#7e8299',
    fontWeight: '500',
    margin: '0',
    width: 'auto',
    padding: '1rem 2rem',
    top: 'calc(50% - 2rem)',
    left: 'calc(50% - 4rem)',
  }

  if (isLoading) {
    return <div style={{...styles, position: 'absolute', textAlign: 'center'}}>Processing...</div>
  }

  console.log('Response -->:', data)

  return (
    <>
      <div className='row flex-md-block '>
        <div className='col-sm-12 col-md-6 col-lg-6'>
          <h1 className='inv-hst sm-ms-2'> View Group Meeting Reports </h1>
        </div>

        <div className='col-sm-12  col-md-6 col-lg-6 text-end pe-5'>
          <button
            onClick={navigateGroupMeeting}
            className='btn btn-info btn-sm waves-effect waves-light '
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>

      <div className='card  p-8 mt-5 visitor-details'>
        <div className='row pb-10 mb-8 border-bottom border-gray-300'>
          <div className='col-sm-12 col-md-6 col-lg-4 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'>Report Submitted For Group:</div>
            <div className='text-dark fs-4 text-start fw-bold '>
              {checkDisplayValue(data?.groupName[0])}
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-lg-4 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'> &nbsp; </div>
            <div className='text-dark fs-4 text-start fw-bold '> &nbsp; </div>
          </div>
          <div className='col-sm-12 col-md-6 col-lg-4 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'>Agenda of the meeting:</div>
            <div className='text-dark fs-4 text-start fw-bold '>
              {checkDisplayValue(data?.agenda_of_meeting)}
            </div>
          </div>

          <div className='col-sm-12 col-md-6 col-lg-4 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'>Meeting Date:</div>
            <div className='text-dark fs-4 text-start fw-bold '>
              {data?.meeting_date
                ? checkDisplayValue(moment(data?.meeting_date).format('DD/MM/YYYY'))
                : '-'}
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-lg-4 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'> Meeting Start Time: </div>
            <div className='text-dark fs-4 text-start fw-bold '>
              {' '}
              {data?.start_time
                ? checkDisplayValue(moment(data?.start_time, 'HH:mm').format('HH:mm'))
                : '-'}{' '}
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-lg-4 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'>Meeting End Time:</div>
            <div className='text-dark fs-4 text-start fw-bold '>
              {data?.end_time
                ? checkDisplayValue(moment(data?.end_time, 'HH:mm').format('HH:mm'))
                : '-'}
            </div>
          </div>
        </div>
        <div className='row pb-10 mb-8 border-bottom border-gray-300'>
          <div className='col-sm-12 col-md-6 col-lg-4 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'>Participants:</div>
            <div className='text-dark fs-4 text-start fw-bold '>
              {data?.participantNames?.map((item: any) => (
                <>
                  {/* <li> */} <i className='fa-solid fa-check fs-7 text-success'></i>{' '}
                  {checkDisplayValue(item)}
                  <br></br>
                  {/* </li> */}
                </>
              ))}
            </div>
          </div>
        </div>

        <div className='row pb-10 mb-8'>
          <div className='col-sm-12 col-md-6 col-lg-6 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'>What Went Well:</div>
            <div className='text-dark fs-6 text-start fw-medium '>
              {data?.whatWentWell?.map((item: any) => (
                // <ul>
                <li className='lh-lg'> {checkDisplayValue(item)} </li>
                // </ul>
              ))}
            </div>
          </div>

          <div className='col-sm-12 col-md-6 col-lg-6 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'>What Can Be Improved:</div>
            <div className='text-dark fs-6 text-start fw-medium '>
              {data?.whatCanBeImproved?.map((item: any) => (
                // <ul>
                <li className='lh-lg'> {checkDisplayValue(item)} </li>
                // </ul>
              ))}
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-lg-6 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'>Any Other Comments:</div>
            <div className='text-dark fs-4 text-start fw-bold '>
              {' '}
              {checkDisplayValue(data?.comments)}{' '}
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-sm-12 col-md-6 col-lg-6 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'>Group Photo:</div>
            <div className='text-dark fs-4 text-start fw-bold '>
              <Zoom>
                <img
                  src={
                    data?.image
                      ? `${API_URL}/containers/topicimages/download/${data?.image}`
                      : `${process.env.PUBLIC_URL}/media/icons/duotune/default-user.png`
                    // : `${toAbsoluteUrl('./media/icons/duotune/default-user.png')}`
                  }
                  alt=''
                  width={100}
                  className='thumbnail-img'
                  onError={({currentTarget}: any) => {
                    currentTarget.onerror = null // prevents looping
                    currentTarget.src = `${process.env.PUBLIC_URL}/media/avatars/default-user.png`
                    // currentTarget.src =`${toAbsoluteUrl('./media/icons/duotune/default-user.png')}`
                  }}
                />
              </Zoom>
            </div>
          </div>
        </div>

        <div className='row  '>
          <div className='col-sm-12 col-md-6 col-lg-6 mb-8'>
            <div className='text-dark fs-4 text-start pb-1'>Submitted By:</div>
            <div className='text-dark fs-4 text-start fw-bold '>
              {' '}
              {checkDisplayValue(data?.submittedByName[0])}{' '}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewGroupMeetingReports
